import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { IHallBookingReceipt } from "src/domain/entities"
import { hallBookingReceiptDeleteService } from "src/domain/services/hallBookingReceiptCategory/hallBookingReceiptCategoryDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"

interface Props {
	hallBookingReceipt: IHallBookingReceipt
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const HallBookingReceiptDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	hallBookingReceipt,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleHallBookingReceiptDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await hallBookingReceiptDeleteService({ id: hallBookingReceipt.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [hallBookingReceipt, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Hall Booking Receipt: ${hallBookingReceipt.hallBookingReceiptNo}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleHallBookingReceiptDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
